import { FilterBar } from '@/components/filters/FilterBar';
import { SearchInput } from '@/components/filters/SearchInput';
import { useAdminDomains } from '@/hooks/useAdminDomains';
import { useState } from 'react';
import { DomainsTable } from '../components/DomainsTable';

export function DomainsListPage() {
  const [search, setSearch] = useState('');
  const { data, isLoading } = useAdminDomains({ search, limit: 25 });
  const domains = data?.data || [];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Domaines</h1>
        <p className="text-sm text-neutral-500">{data?.pagination?.totalItems ?? 0} domaines</p>
      </div>
      <FilterBar>
        <div className="w-72">
          <SearchInput value={search} onChange={setSearch} placeholder="Rechercher un domaine..." />
        </div>
      </FilterBar>
      <DomainsTable data={domains} loading={isLoading} />
    </div>
  );
}
